import { Progress } from '@chakra-ui/react';

import React from 'react';

const LoadingSpinner = ({ size = 'md' }) => {
  return (
    <Progress.Root value={null} colorPalette={'purple'} size={size}>
      <Progress.Track>
        <Progress.Range />
      </Progress.Track>
    </Progress.Root>
  );
};

export default LoadingSpinner;
